
import { defineComponent, nextTick, ref, watch } from "vue";
import { ElDialog } from "element-plus";
import { useDialogCommon } from "@/hooks/";
import { momentFormat } from "@/utils/formatter";

export default defineComponent({
  name: "FormDialog",

  props: {
    visible: { type: Boolean, default: false },
    customClass: { type: String, default: "form-dialog" },
    title: { type: String, default: "消息详情" },
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    width: { type: [String, Number], default: "50%" },
    inline: { type: Boolean, default: false },
    fullscreen: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: false },
    closeOnPressEscape: { type: Boolean, default: true },
    destroyOnClose: { type: Boolean, default: false },
    appendToBody: { type: Boolean, default: false },
    showClose: { type: Boolean, default: true },
  },

  emits: ["update:visible"],

  setup(props, context) {
    const dialogRefs = ref<typeof ElDialog | null>(null);
    const { visibleRef } = useDialogCommon(props, context);

    watch(
      () => visibleRef.value,
      (n) => {
        if (n) {
          nextTick(() => {
            if (dialogRefs.value) {
              const dialogBody = (
                dialogRefs.value.$el.nextElementSibling as HTMLElement
              ).querySelector(".el-dialog__body");
              if (dialogBody) {
                dialogBody?.scrollTo(0, 0);
              }
            }
          });
        }
      }
    );

    return {
      dialogRefs,
      visibleRef,
      momentFormat
    };
  },
});
